import {json} from './json.mapper';

export class ErrorResponse {
    @json()
    code: number;
    @json()
    message: string;
    @json()
    metadata: any;
}
